import TrackingPageProvider from '../data/providers/TrackingPageProvider';
import {
  stopCommonLoader,
  startCommonLoader,
} from './uiActions';
import {
  GET_TRACKING_PAGE,
} from '../constants/loaderTypes';

export const GET_TRACKING_PAGE_SUCCESS = 'GET_TRACKING_PAGE_SUCCESS';
export const GET_TRACKING_PAGE_FAILURE = 'GET_TRACKING_PAGE_FAILURE';

export const getTrackingPageSuccess = (data, request, version, isPreview) => ({
  type: GET_TRACKING_PAGE_SUCCESS,
  payload: {
    data,
    request,
    version,
    isPreview,
  },
});

export const getTrackingPageFailure = (response) => ({
  type: GET_TRACKING_PAGE_FAILURE,
  payload: {
    response,
  },
});

// -------------------------------------------------------------------------------------------------------------

export function getTrackingPage(
  trackingPageName,
  shipmentId,
  customerId,
  version,
  isPreview,
  trackingReference,
  customReference,
  metadataKey,
  metadataValue,
) {
  return async (dispatch) => {
    dispatch(startCommonLoader(GET_TRACKING_PAGE));
    try {
      const { data, result } = await TrackingPageProvider.getTrackingPage(
        trackingPageName,
        shipmentId,
        customerId,
        version,
        trackingReference,
        customReference,
        metadataKey,
        metadataValue,
      );
      if (result.success) {
        dispatch(getTrackingPageSuccess(data, {
          trackingPageName,
          shipmentId,
          customerId,
          trackingReference,
          customReference,
        }, version, isPreview));
      } else {
        dispatch(getTrackingPageFailure(result));
      }
    } finally {
      dispatch(stopCommonLoader(GET_TRACKING_PAGE));
    }
  };
}
